import { render } from "./UnifiedCreateScreen.vue?vue&type=template&id=5afad1e6&scoped=true"
import script from "./UnifiedCreateScreen.vue?vue&type=script&lang=js"
export * from "./UnifiedCreateScreen.vue?vue&type=script&lang=js"

import "./UnifiedCreateScreen.vue?vue&type=style&index=0&id=5afad1e6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afad1e6"]])

export default __exports__